import approval from "./approvalCheck";
import clipboard from "./clipboard/clipboard";
import dialogDrag from "./dialogDrag";
import format from "./money";
import fullscreen from "./dialogFullscreen";
import loadmore from "./loadmore";
import numberFormat from "./numberFormat";
import numberInput from "./numberInput";
import onlyInputNum from "./onlyInputNum";
import permission from "./permission";
import selectDrop from "./selectDrop";
import tableFixed from "./tableFixed";
import tableScroll from "./tableScroll";
import tableSelect from "./tableSelect";
import tableSelection from "./tableSelection";
import inputWidth from "./inputWidth";

export default {
    approval,
    clipboard,
    dialogDrag,
    loadmore,
    format,
    fullscreen,
    numberFormat,
    numberInput,
    onlyInputNum,
    permission,
    selectDrop,
    tableFixed,
    tableScroll,
    tableSelect,
    tableSelection,
    inputWidth
};
